<template>
    <footer class="py-5 bg-blue txt-white">
		<div class="container">
			<div class="row">
				<div class="col-md-6 col-lg-8 text-left mb-4 mb-md-0">
                    <Logo outerClass="mb-4" innerClass="logo" type="png" altText="My Fast Cash" />
					&copy; 2020 {{VUE_APP_SITE_NAME}}<sup class="p10">SM</sup>
				</div><!--End Col 8-->
				<div class="col-sm-6 col-md-3 col-lg-2 p16 mb-5 mb-md-0">
					<h6 class="mb-4">Legal</h6>
					<router-link to="/legal/tos">Terms of Service</router-link><br>
					<router-link to="/legal/privacy">Privacy Policy</router-link><br>
					<router-link to="/legal/california">CCPA Privacy Notice</router-link><br>
					<router-link to="/legal/disclaimer">Disclaimer</router-link><br>
					<router-link to="/legal/e-consent">E-Consent</router-link><br>
					<router-link to="/unsubscribe">Unsubscribe</router-link><br>
				</div><!--End Col 2-->
				<div class="col-sm-6 col-md-3 col-lg-2 p16">
					<h6 class="mb-4">Company</h6>
					<router-link to="/">Home</router-link><br>
                    <router-link to="/#why-choose-us">Why Choose Us</router-link><br>
                    <router-link to="/#how-it-works">How it Works</router-link><br>
                    <router-link to="/#faq">FAQ</router-link><br>
                    <router-link to="/apply/1">Get Started</router-link>
				</div><!--End Col 2-->
			</div><!--End Row-->
		</div><!--End Container-->
	</footer>
</template>

<script>
import Logo from '@/components/Logo.vue';

export default {
    name: 'Footer',
    components: {
        Logo
    },
    computed: {
        VUE_APP_SITE_NAME(){
            return process.env.VUE_APP_SITE_NAME
        }
    }
}
</script>

<style>

</style>
